import { addHours, format as fnsFormat, subHours } from 'date-fns';
import { CONFIG } from 'shared/config/config';

export const getConvertedDate = (date: Date) => {
  return addHours(new Date(date), CONFIG.DATE_ADD_HOUR);
};

export const getSubConvertedDate = (date: Date) => {
  return subHours(new Date(date), CONFIG.DATE_ADD_HOUR);
};

export const getFormattedDate = (date: Date, format?: string) => {
  return fnsFormat(getConvertedDate(date), format || 'eee, LLL dd, yyyy hh:mm a');
};

export const getModifiedFormattedDate = (date: Date, formatString?: string, minusHours?: boolean) => {
  return fnsFormat(
    minusHours ? getSubConvertedDate(date) : getConvertedDate(date),
    formatString || 'eee, LLL dd, yyyy hh:mm a',
  );
};
